var _circle, _path, _path2, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMycomplaints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 249.5,
    r: 233.528,
    fill: "white",
    stroke: "white",
    strokeWidth: 31.9448
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.328 314.084H254.436L252.954 315.26L180.386 372.826L176.808 319.153L176.47 314.084H171.39H167.124C149.559 314.084 135.32 299.845 135.32 282.281V179.114C135.32 161.549 149.559 147.311 167.124 147.311H333.897C351.462 147.311 365.701 161.55 365.701 179.114V282.281C365.701 299.845 351.462 314.084 333.897 314.084H256.328Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 10.8597
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.125 248.926L249.947 180.435",
    stroke: "#4045A1",
    strokeWidth: 17.6247,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.961,
    cy: 279.574,
    r: 8.81236,
    fill: "#4045A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMycomplaints);
export default __webpack_public_path__ + "static/media/mycomplaints.9457aa90220828dfda9eb255e4fb3176.svg";
export { ForwardRef as ReactComponent };